import { Injectable } from '@angular/core';
import jwt_decode from 'jwt-decode';
import { Observable, Subject } from 'rxjs';
import { Token } from './token.model';

@Injectable({
	providedIn: 'root',
})
export class TokenService {
	KEY = 'AuthToken';

	private cachedToken: Token = null;

	private userSubject: Subject<Token> = new Subject<Token>();

	public setToken(encodedToken: string): void {
		window.localStorage.setItem(this.KEY, encodedToken);

		const decodedToken: Token = jwt_decode(encodedToken);
		this.cachedToken = decodedToken;
		this.userSubject.next(decodedToken);
	}

	public removeToken(): void {
		window.localStorage.removeItem(this.KEY);

		this.cachedToken = null;
		this.userSubject.next(null);
	}

	public getEncodedToken(): string {
		return String(window.localStorage.getItem(this.KEY));
	}

	public getTokenAsObservable(): Observable<Token> {
		return this.userSubject.asObservable();
	}

	public getTokenAsValue(): Token {
		return this.cachedToken;
	}
}
